module.exports = __webpack_public_path__ + "static/img/salepage-stk-shipment_19.6b91523.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salepage/banner/shipment/salepage-stk-shipment_19.webp
// module id = pXKC
// module chunks = 134